<template>
    <div class="tableHeader tableRow" :style="[rowStyle]">
        <div class="tableCell" v-for="col in columns" :key="col.name" :class="{ 'numberFormat': isNumberFormat(col) }">
            <span class="tableCell__content" :class="{ '--clickable': col.isSortable }"
                  v-on:click="$emit('sortBy', col)">
                
                <slot :column="col">{{ col.name }}</slot>
                
                <span class="sortBtn fa fa-sort" v-if="col.isSortable"
                      :class="{'--active': false}"></span>
            </span>
        </div>
    </div>
</template>

<script>
import {isNumberColumn} from "@/2_app-logic/utils/utils";

const props = {
    columns: Array,
    rowStyle: Object,
}

export default {
    name: 'zTableHeader',
    props: props,
    data: () => ({
        isNumberFormat: isNumberColumn,
    }),
    computed: {
    
    },
    methods: {
    
    },
}
</script>

<style lang="less">

</style>